import { Component, Input, ViewChild, AfterViewInit } from "@angular/core";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { EdpModalService } from "@edp-components/edp-modal";
import { IDependents } from "@edp-models/edp-pack-subscriber.model";
import { NgbAccordion, NgbPanelChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { NifValidator } from "@edp-validators/nif.validator";
import { EmailValidator } from "@edp-validators/email.validator";
import { PhoneValidator } from "@edp-validators/phone.validator";
import { WhitespaceValidator } from "@edp-validators/whitespace.validator";
import { Pack } from "@edp-components/edp-pack";
import { PackSubscriberService } from "@edp-services/pack-subscriber.service";
import { OperationHistoryService } from "@edp-services/operation-history.service";
import { Contract } from "@edp-components/edp-contract";
import { GoogleAnalyticsService } from "@edp-services/google-analytics.service";

@Component({
    selector: "edp-pack-health-modal",
    templateUrl: "./edp-pack-health-modal.component.html",
    styleUrls: ["./edp-pack-health-modal.component.scss"],
})
export class EdpPackHealthModalComponent implements AfterViewInit {
    @Input() public data: IDependents[] = [];
    @ViewChild("acc", { static: true }) accordionComponent: NgbAccordion;
    public pack: Pack;
    public readonly LIMIT: number = 4;
    public forms: FormGroup[] = [];
    public isSubmited = false;
    public currentPanel: number;
    public disabledBtn = false;
    public hasEnable = false;
    private contract: Contract;

    constructor(
        private formBuilder: FormBuilder,
        private edpModalService: EdpModalService,
        private packSubscriberService: PackSubscriberService,
        private operationHistoryService: OperationHistoryService,
        private googleAnalyticsService: GoogleAnalyticsService
    ) {
        this.pack = this.packSubscriberService.getPack();
        this.contract = this.packSubscriberService.getContract();
    }

    ngAfterViewInit(): void {
        if (this.data.length > 0) {
            this.data.forEach((dependent: IDependents) => this.addDependent(dependent));
            return;
        }

        this.addDependent();
    }

    public addDependent(dependent?: IDependents): void {
        this.forms.push(
            this.formBuilder.group({
                name: [
                    dependent ? dependent.name : null,
                    [Validators.required, Validators.minLength(3), WhitespaceValidator]
                ],
                nif: [
                    dependent ? dependent.nif : null,
                    [Validators.required, NifValidator()]
                ],
                birthDate: [
                    dependent ? dependent.birthDate : null,
                    [Validators.required]
                ],
                phone: [
                    dependent ? dependent.phone : null,
                    [Validators.required, PhoneValidator()]
                ],
                email: [
                    dependent ? dependent.email : null,
                    [Validators.required, EmailValidator]
                ],
                owner: [
                    false,
                    [Validators.required]
                ],
            })
        );
        this.isSubmited = false;
        this.expandCurrentPanel();
    }

    public removeDependent(index: number): void {
        this.forms.splice(index, 1);
        this.expandCurrentPanel();
    }

    private expandCurrentPanel(): void {
        const currentIndex: number = this.forms.length - 1;
        setTimeout(() => this.expandPanel(currentIndex), 10);
    }

    private expandPanel(index: number): void {
        this.accordionComponent.expand(`dependent-${index}`);
    }

    private checkFormsErrors(): boolean {
        return this.forms.some(form => form.invalid);
    }

    private getFormValues(): IDependents[] {
        const values: IDependents[] = [];

        this.forms.forEach(form => {
            values.push(form.value);
        });

        return values;
    }

    public setCurrentPanel(event: NgbPanelChangeEvent): void {
        const currentIndex: number = Number(event.panelId.split("-").pop());
        this.currentPanel = event.nextState ? currentIndex : -1;
    }

    public close(): void {
        this.isSubmited = true;

        if (!this.checkFormsErrors()) {
            this.data = this.getFormValues();

            this.googleAnalyticsService.datalayerEvent("SUBSCRIBE_PACK_ADD_BENEFICIARY");
            this.operationHistoryService.registerWithContract(this.contract.ContractId, "SUBSCRIBE_PACK_ADD_BENEFICIARY", this.data.length);
            this.operationHistoryService.registerWithContract(this.contract.ContractId, "SUBSCRIBE_PACK_BENEFICIARY_CONFIRM", "Aceitar");

            this.edpModalService.close(this.data);

        } else {
            const index: number = this.forms.findIndex(form => form.invalid);
            this.expandPanel(index);
        }
    }

    public dismiss(): void {
        this.operationHistoryService.registerWithContract(this.contract.ContractId, "SUBSCRIBE_PACK_BENEFICIARY_CONFIRM", "Cancelar");

        this.edpModalService.dismiss(false);
    }
}
